import type { ReactNode } from 'react'
import { Skeleton, Typography, theme } from 'antd'

interface AmountCardProps {
  label: string
  /** Tayyor matn — formatlash chaqiruvchida (valyuta u yerda ma'lum) */
  value: string
  /** Yorliq ostidagi izoh: «cheklov yo'q», «sozlanmagan» va h.k. */
  hint?: ReactNode
  /**
   * EKRANDAGI ASOSIY RAQAM — rejimga qarab BOSHQA maydon bo'ladi
   * (`DEPOSIT` da `available`, `POSTPAID` da `outstanding`; §6).
   * Bir ekranda faqat bittasi.
   */
  primary?: boolean
  tone?: 'default' | 'danger' | 'warning'
  loading?: boolean
}

const TONE_TYPE = {
  default: undefined,
  danger: 'danger',
  warning: 'warning',
} as const

/**
 * Bitta son va uning yorlig'i.
 *
 * ⚠️ IERARXIYA KESKIN VA BU ATAYLAB. Sherik sahifani bitta savol bilan
 * ochadi va u rejimga qarab boshqacha: depozitlida «qancha bera olaman»,
 * postpaidda «qancha topshirishim kerak». Javob 28–32 piksellik son
 * bo'lib turadi, qolgani — kichik kulrang qator. Uchta bir xil
 * kattalikdagi karta uchala savolni ham teng qilib, hech qaysisiga
 * javob bermasdi.
 *
 * ⚠️ `@ant-design/plots` QO'SHILMAYDI (§9-4): sherikka trend emas,
 * bitta son kerak.
 */
export function AmountCard({
  label,
  value,
  hint,
  primary = false,
  tone = 'default',
  loading = false,
}: AmountCardProps) {
  const { token } = theme.useToken()

  return (
    <div
      style={{
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        padding: primary ? '16px 18px' : '12px 14px',
        flex: primary ? '1 1 100%' : '1 1 160px',
        minWidth: 0,
      }}
    >
      <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block' }}>
        {label}
      </Typography.Text>
      {loading ? (
        <Skeleton.Input active size="small" style={{ width: primary ? 180 : 110, marginTop: 4 }} />
      ) : (
        <Typography.Text
          strong
          {...(TONE_TYPE[tone] ? { type: TONE_TYPE[tone] } : {})}
          style={{
            display: 'block',
            // Telefonda ham, kompyuterda ham o'qiladigan o'lcham (§2)
            fontSize: primary ? 'clamp(28px, 9vw, 32px)' : 18,
            lineHeight: 1.2,
            wordBreak: 'break-word',
          }}
        >
          {value}
        </Typography.Text>
      )}
      {hint ? (
        <Typography.Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 2 }}>
          {hint}
        </Typography.Text>
      ) : null}
    </div>
  )
}
